/**
 * VIARTEART / Stable PDP campaign image.
 * Prestige can replace product-info blocks when Shopify variants change.
 * Reuse the already-decoded campaign image node on re-render so the image
 * does not blank on mobile. Do not intercept price, form or checkout events.
 */
(() => {
  'use strict';
  const selector = '[data-va-static-promo]';
  const roots = new WeakSet();
  function attach(root) {
    if (roots.has(root)) return;
    const banner = root.querySelector(selector);
    const firstImg = banner && banner.querySelector('img');
    if (!firstImg) return;
    roots.add(root);
    let stableImg = firstImg;
    let mutationRunning = false;
    const observer = new MutationObserver((changes) => {
      if (mutationRunning) return;
      // Only act on DOM node replacements, never on price/text updates.
      if (!changes.some(c => c.type === 'childList' && c.addedNodes.length > 0)) return;
      const currentBanner = root.querySelector(selector);
      const currentImg = currentBanner && currentBanner.querySelector('img');
      if (!currentImg || currentImg === stableImg) return;
      const previousSource = stableImg.getAttribute('src');
      const currentSource = currentImg.getAttribute('src');
      if (previousSource && previousSource === currentSource) {
        mutationRunning = true;
        try {
          currentImg.replaceWith(stableImg);
        } finally {
          mutationRunning = false;
        }
      } else {
        // Never keep an outdated promotional image if the merchant changes it.
        stableImg = currentImg;
      }
    });
    observer.observe(root, { childList: true, subtree: true });
  }
  function boot() {
    document.querySelectorAll('product-rerender[allow-partial-rerender]')
      .forEach(attach);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
